(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('bam-reveal--waiting');
      revealObserver.unobserve(entry.target);
    });
  }, {rootMargin:'0px 0px -40px 0px'}) : null;
  const selectAll = (root, selector) => [
    ...(root instanceof Element && root.matches(selector) ? [root] : []),
    ...root.querySelectorAll(selector)
  ];
  const initialize = (root = document) => {
    selectAll(root, '[data-bam-reveal]').forEach(element => {
      if (element.dataset.bamRevealReady) return;
      element.dataset.bamRevealReady = 'true';
      if (!revealObserver || reducedMotion.matches || window.Shopify?.designMode || document.body.dataset.bamRevealEnabled !== 'true') return;
      element.classList.add('bam-reveal');
      if (element.getBoundingClientRect().top >= window.innerHeight - 40) element.classList.add('bam-reveal--waiting');
      revealObserver.observe(element);
    });
    root.querySelectorAll('[data-bam-dialog]').forEach(button => {
      if (button.dataset.bamReady) return;
      button.dataset.bamReady = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.bamDialog);
        if (!dialog) return;
        const form = button.closest('product-info')?.querySelector('product-form form');
        const variant = form?.querySelector('[name=id]')?.value;
        const field = dialog.querySelector('[data-bam-variant]');
        if (field && variant) field.value = variant;
        const configuration = dialog.querySelector('[name="contact[Configuration]"]');
        if (configuration && form) {
          const choices = [...new FormData(form).entries()].filter(([name, value]) => name.startsWith('properties[') && value && !(value instanceof File)).map(([name,value]) => `${name.slice(11,-1)}: ${value}`);
          if (choices.length) configuration.value = choices.join('\n');
        }
        const quantity = dialog.querySelector('[data-bam-quote-quantity]');
        if (quantity && form) quantity.value = form.elements.namedItem('quantity')?.value || 1;
        dialog.showModal();
      });
    });
    root.querySelectorAll('dialog[data-bam-modal]').forEach(dialog => {
      if (dialog.dataset.bamReady) return;
      dialog.dataset.bamReady = 'true';
      dialog.querySelectorAll('[data-bam-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      const result = dialog.querySelector('[data-bam-form-result]');
      if (result && !dialog.open) dialog.showModal();
    });
    root.querySelectorAll('[data-bam-menu]').forEach(details => {
      if (details.dataset.bamReady) return;
      details.dataset.bamReady = 'true';
      let closeTimer;
      details.querySelector('summary')?.addEventListener('click', event => { if (window.matchMedia('(hover:hover)').matches && details.open && event.detail > 0) event.preventDefault(); });
      details.addEventListener('mouseenter', () => { clearTimeout(closeTimer); if (window.matchMedia('(hover:hover)').matches) details.open = true; });
      details.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 180); });
      details.addEventListener('keydown', event => { if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); } });
      details.addEventListener('focusout', () => setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 0));
    });
    root.querySelectorAll('[data-bam-card]').forEach(card => {
      if (card.dataset.bamReady) return;
      card.dataset.bamReady = 'true';
      const images = [...card.querySelectorAll('[data-bam-card-image]')];
      let index = 0;
      const dots = [...card.querySelectorAll('[data-bam-card-index]')];
      const showImage = next => {
        index = (next + images.length) % images.length;
        images.forEach((image, i) => { image.hidden = i !== index; });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index));
      };
      card.querySelectorAll('[data-bam-card-step]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); showImage(index + Number(button.dataset.bamCardStep)); }));
      dots.forEach((dot, i) => dot.addEventListener('click', () => showImage(i)));
    });
    root.querySelectorAll('[data-bam-hero]').forEach(hero => {
      if (hero.dataset.bamReady) return;
      hero.dataset.bamReady = 'true';
      const slides = [...hero.querySelectorAll('[data-bam-slide]')];
      const dots = [...hero.querySelectorAll('[data-bam-slide-to]')];
      let index = 0;
      const show = i => { index = i; slides.forEach((slide, n) => { slide.classList.toggle('is-active', n === i); slide.inert = n !== i; }); dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i)); };
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      show(0);
      if (hero.dataset.bamAutoplay === 'true' && slides.length > 1 && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
        const interval = setInterval(() => { if (document.contains(hero) && !hero.matches(':hover') && !hero.contains(document.activeElement)) show((index + 1) % slides.length); else if (!document.contains(hero)) clearInterval(interval); }, Number(hero.dataset.bamInterval || 5) * 1000);
      }
    });
    root.querySelectorAll('[data-bam-article]').forEach(article => {
      if (article.dataset.bamReady) return;
      article.dataset.bamReady = 'true';
      const headings = [...article.querySelectorAll('.bam-article-copy h2')].filter(h => h.textContent.trim());
      const lists = article.querySelectorAll('[data-bam-toc-list]');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${article.id}-section-${index + 1}`;
        lists.forEach(list => { const li = document.createElement('li'); const a = document.createElement('a'); a.href = `#${heading.id}`; a.textContent = heading.textContent.trim(); li.append(a); list.append(li); });
      });
      if (!headings.length) { article.querySelectorAll('.bam-toc').forEach(t => t.hidden = true); article.querySelector('.bam-article-layout')?.classList.add('bam-article-layout--plain'); }
      if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { entries.forEach(entry => { if (entry.isIntersecting) article.querySelectorAll('[data-bam-toc-list] a').forEach(a => a.setAttribute('aria-current', a.hash === `#${entry.target.id}`)); }); }, {rootMargin:'-100px 0px -65% 0px'}); headings.forEach(h => observer.observe(h)); }
    });
  };
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('product-info:loaded', event => initialize(event.target));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node instanceof HTMLElement) initialize(node); }))).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => selectAll(event.target, '[data-bam-reveal]').forEach(element => revealObserver?.unobserve(element)));
  document.addEventListener('shopify:section:select', event => selectAll(event.target, '[data-bam-reveal]').forEach(element => element.classList.remove('bam-reveal--waiting')));
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    document.querySelectorAll('.bam-reveal--waiting').forEach(element => {
      element.classList.remove('bam-reveal--waiting');
      revealObserver?.unobserve(element);
    });
  });
  document.addEventListener('click', event => { if (!event.target.closest('[data-bam-menu]')) document.querySelectorAll('[data-bam-menu][open]').forEach(menu => menu.open = false); });
  let lastScrollY = window.scrollY;
  const onScroll = () => {
    const currentScrollY = window.scrollY;
    document.querySelector('[data-bam-top]')?.classList.toggle('is-visible', currentScrollY > 500);
    document.querySelectorAll('.bam-header[data-bam-sticky="true"]').forEach(header => {
      const scrolled = currentScrollY > 200;
      const returning = currentScrollY < lastScrollY || header.contains(document.activeElement) || !!header.querySelector('details[open]');
      header.classList.toggle('is-scrolled', scrolled);
      if (!scrolled) header.classList.remove('is-returning');
      else if (Math.abs(currentScrollY - lastScrollY) > 2) header.classList.toggle('is-returning', returning);
    });
    lastScrollY = currentScrollY;
  };
  document.addEventListener('scroll', onScroll, {passive:true});
  document.addEventListener('click', event => { if (event.target.closest('[data-bam-top]')) window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}); });
  if (document.readyState !== 'loading') initialize();
})();

class BamBlogSlider extends HTMLElement {
  connectedCallback() {
    if (this.track) return;
    this.track = this.querySelector('[data-bam-blog-track]');
    if (!this.track) return;
    this.controls = this.querySelector('[data-bam-blog-controls]');
    this.previous = this.querySelector('[data-bam-blog-prev]');
    this.next = this.querySelector('[data-bam-blog-next]');
    this.current = this.querySelector('[data-bam-blog-current]');
    this.total = this.querySelector('[data-bam-blog-total]');
    this.onPrevious = () => this.move(-1);
    this.onNext = () => this.move(1);
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    };
    this.onKey = event => {
      if (!this.active || event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') this.goTo(event.key === 'Home' ? 0 : this.maxScroll);
      else this.move((event.key === 'ArrowRight' ? 1 : -1) * this.direction);
    };
    this.previous?.addEventListener('click', this.onPrevious);
    this.next?.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, {passive:true});
    this.track.addEventListener('keydown', this.onKey);
    this.onResize = () => this.measure();
    window.addEventListener('resize', this.onResize, {passive:true});
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);
    }
    this.measure();
  }

  measure() {
    this.active = (matchMedia('(max-width:767px)').matches ? this.dataset.mobileLayout : this.dataset.desktopLayout) === 'slider';
    const style = getComputedStyle(this.track);
    this.direction = style.direction === 'rtl' ? -1 : 1;
    const first = this.track.querySelector('.bam-post-card');
    this.step = first ? first.offsetWidth + (parseFloat(style.columnGap) || 0) : 1;
    this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.pages = Math.ceil(Math.max(0, this.maxScroll - 2) / Math.max(1, this.step)) + 1;
    this.controls.hidden = !this.active || this.maxScroll < 2;
    if (this.active && this.maxScroll > 1) {
      this.track.tabIndex = 0;
    } else this.track.removeAttribute('tabindex');
    this.update();
  }

  update() {
    const position = Math.abs(this.track.scrollLeft);
    const atEnd = position >= this.maxScroll - 2;
    this.previous.disabled = !this.active || position <= 2;
    this.next.disabled = !this.active || atEnd;
    const page = atEnd ? this.pages : Math.min(this.pages, Math.round(position / Math.max(1, this.step)) + 1);
    this.current.textContent = String(page);
    this.total.textContent = String(this.pages);
  }

  move(direction) {
    this.goTo(Math.max(0, Math.min(this.maxScroll, Math.abs(this.track.scrollLeft) + direction * this.step)));
  }

  goTo(position) {
    this.track.scrollTo({left:this.direction * position, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.onResize);
    this.previous?.removeEventListener('click', this.onPrevious);
    this.next?.removeEventListener('click', this.onNext);
    this.track?.removeEventListener('scroll', this.onScroll);
    this.track?.removeEventListener('keydown', this.onKey);
    this.track = null;
  }
}

if (!customElements.get('bam-blog-slider')) customElements.define('bam-blog-slider', BamBlogSlider);
